import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/common/ui/table'
import { ScrollArea } from '@/common/ui/scroll-area'
import { Badge } from '@/common/ui/badge'
import { PaymentGatewayErrorResponse } from '../../types'

interface PaymentGatewayErrorsModalProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	errors: PaymentGatewayErrorResponse[]
	transactionId: string
}

export default function PaymentGatewayErrorsModal({
	open,
	onOpenChange,
	errors,
	transactionId,
}: PaymentGatewayErrorsModalProps) {
	const formatDate = (date: string) => {
		return format(new Date(date), 'PPP HH:mm น.', { locale: th })
	}

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-4xl">
				<DialogHeader>
					<DialogTitle>สาเหตุ</DialogTitle>
					<p className="text-sm text-muted-foreground">
						รหัสธุรกรรม: {transactionId}
					</p>
				</DialogHeader>
				<ScrollArea className="max-h-[60vh]">
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>ID</TableHead>
								<TableHead>ธนาคารออโต้</TableHead>
								<TableHead>ข้อมูล</TableHead>
								<TableHead>สถานะ</TableHead>
								<TableHead>วันที่สร้าง</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{errors.length > 0 ? (
								errors.map((error) => (
									<TableRow key={error.id}>
										<TableCell className="font-mono text-xs">
											{error.id}
										</TableCell>
										<TableCell>
											{error.paymentGateway?.bankProviderName || '-'}
										</TableCell>
										<TableCell>{error.errorMessage}</TableCell>
										<TableCell>
											{'isUnderMaintenance' in error &&
											error.isUnderMaintenance ? (
												<Badge
													variant="secondary"
													className="bg-amber-500/15 text-amber-700 dark:bg-amber-500/20 dark:text-amber-400"
												>
													ภายใต้การซ่อมบำรุง
												</Badge>
											) : (
												'-'
											)}
										</TableCell>
										<TableCell>{formatDate(error.createdAt)}</TableCell>
									</TableRow>
								))
							) : (
								<TableRow>
									<TableCell colSpan={5} className="text-center">
										ไม่พบข้อมูล log ธนาคารออโต้
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</ScrollArea>
			</DialogContent>
		</Dialog>
	)
}
